import {FormattedPhoneNumber, phoneNumberPattern} from "./replacement-renderer";

export function buildSwapTarget(number: string) {
    if (number.startsWith('+1')) {
        return number;
    }

    if (number.startsWith('1')) {
        return '+' + number;
    }

    return '+1' + number;
}

export function reformatPhoneNumber(targetFormat: string, phoneNumber: string): string {
    const replacementChars = phoneNumber.split('');
    const originalChars = targetFormat.split('').filter(c => c !== "\n");

    if (targetFormat.match(/([a-zA-Z])/)) {
        return reformatPhoneNumber('(000) 000-0000', phoneNumber);
    }

    for (let i = originalChars.length; i > 0; i--) {
        if (originalChars[i - 1] !== ' ' && !isNaN(originalChars[i - 1] as unknown as number)) {
            originalChars[i - 1] = replacementChars.pop() as unknown as string;
        }
    }

    return originalChars.join('');
}

export function findAllPhoneNumbers(text: string): FormattedPhoneNumber[] {
    // Strip invisible Unicode formatting characters from PDFs (directional marks, zero-width spaces, etc.)
    const cleanText = text.replace(/[\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g, '');

    const formattedPhoneNumbers: FormattedPhoneNumber[] = [];
    for (let match of cleanText.matchAll(phoneNumberPattern)) {
        const [originalFormat, ...groups] = match;
        const parts = groups.slice(0, -1);

        formattedPhoneNumbers.push({
            originalFormat: originalFormat.trim(),
            raw: parts.join(''),
        });
    }

    return formattedPhoneNumbers;
}

/**
 * @see https://github.com/thiagodp/get-xpath/blob/master/src/index.ts
 *
 * Their bundle size is 24kb, just copying this over to avoid that overhead.
 */
export type Options = {
    ignoreId: boolean
};

const defaultOptions: Options = {
    ignoreId: false
};

export function getXPath( el: any, customOptions?: Partial< Options > ): string {
    const options = { ...defaultOptions, ...customOptions };
    let nodeElem = el;
    if ( nodeElem && nodeElem.id && ! options.ignoreId ) {
        return "//*[@id=\"" + nodeElem.id + "\"]";
    }
    let parts: string[] = [];
    while ( nodeElem && Node.ELEMENT_NODE === nodeElem.nodeType ) {
        let nbOfPreviousSiblings = 0;
        let hasNextSiblings = false;
        let sibling = nodeElem.previousSibling;
        while ( sibling ) {
            if ( sibling.nodeType !== Node.DOCUMENT_TYPE_NODE &&
                sibling.nodeName === nodeElem.nodeName
            ) {
                nbOfPreviousSiblings++;
            }
            sibling = sibling.previousSibling;
        }
        sibling = nodeElem.nextSibling;
        while ( sibling ) {
            if ( sibling.nodeName === nodeElem.nodeName ) {
                hasNextSiblings = true;
                break;
            }
            sibling = sibling.nextSibling;
        }
        let prefix = nodeElem.prefix ? nodeElem.prefix + ":" : "";
        let nth = nbOfPreviousSiblings || hasNextSiblings
            ? "[" + ( nbOfPreviousSiblings + 1 ) + "]"
            : "";
        parts.push( prefix + nodeElem.localName + nth );
        nodeElem = nodeElem.parentNode;
    }
    return parts.length ? "/" + parts.reverse().join( "/" ) : "";
}